import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  for: "example1",
  class: "date-field-container__label"
}
const _hoisted_2 = {
  key: 1,
  class: "date-field-content"
}
const _hoisted_3 = {
  key: 0,
  for: "example1",
  class: "date-field-container__label"
}
const _hoisted_4 = { class: "date-picker-component date-field-container__date-picker-component" }

import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { computed, onMounted, ref, watch } from 'vue';
import AppDatePicker from '@/corePagesModule/components/AppDatePicker.vue';
import { CustomStyle } from '@/appLogic/interfaces/style';
import { appendImportantStyle } from '@/utils/display/styleUtil';

// interface

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'DateField',
  props: {
    inputDate: { default: undefined },
    format: { default: 'yyyy-MM-dd' },
    labelName: { default: '' },
    labelDirection: { default: 'row' },
    customStyle: { default: undefined },
    isModal: { type: Boolean, default: false },
    disabledDates: { type: [Function, Array], default: () => [] }
  },
  emits: ["changeValue"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "4c898b0e": (_ctx.$props.isModal ? `276px` : `10rem`),
  "7b6e1154": (_ctx.$props.isModal ? `55px` : `95%`),
  "1a428e32": (_ctx.$props.isModal ? `55px` : `41.8px`),
  "ccaf9da8": (_ctx.$props.isModal ?`1px solid black`:`2px solid black`)
}))

const props = __props;

// emits
const emits = __emit;
// style variables
// TODO: ここの'row'って何のためにある？
// const Div =
//   props.labelDirection === 'row'
//     ? styled.div`
//         display: grid;
//         align-items: center;
//         grid-template-columns: 8em minmax(0, 2fr);
//         grid-template-rows: minmax(0, 1fr);
//         ${{ ...appendImportantStyle(props?.customStyle?.['Div'] ?? {}) }}
//       `
//     : styled.div`
//         display: grid;
//         align-items: center;
//         grid-template-columns: minmax(0, 1fr);
//         grid-template-rows: repeat(2, minmax(0, 1fr));
//         ${{ ...appendImportantStyle(props?.customStyle?.['Div'] ?? {}) }}
//       `;

const Label = styled.label`
  ${{ ...appendImportantStyle(props?.customStyle?.['Label'] ?? {}) }}
`;
const VueDatePickerComponent = styled.div`
  ${{
    ...appendImportantStyle(props?.customStyle?.['VueDatePickerComponent'] ?? {}),
  }}
`;

//変数
const t = i18n.t;
const locale = computed(() => i18n.locale);

//computed
const date = computed({
  get: () => props.inputDate,
  set: (value) => {
    // 値に変更があると呼ばれるsetter
    if (!value) {
      return;
    }
    emits('changeValue', value);
  },
});

// イベント
onMounted(() => {});

//関数
const isShowLabel = (): boolean => {
  return !!props.labelName;
};

return (_ctx: any,_cache: any) => {
  return (_ctx.isModal)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (isShowLabel())
          ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_unref(t)(_ctx.labelName)), 1))
          : _createCommentVNode("", true),
        _createVNode(VueDatePickerComponent, null, {
          default: _withCtx(() => [
            _createVNode(AppDatePicker, {
              modelValue: date.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
              class: "date-field__input",
              "mode-height": 1,
              format: _ctx.format,
              "enable-time-picker": true,
              inline: { input: true },
              "month-change-on-scroll": false,
              "disabled-dates": props.disabledDates,
              "text-input": "",
              "auto-apply": "",
              "week-start": "0",
              locale: locale.value,
              placeholder: _unref(t)('日付を選択'),
              "show-now-button": true,
              "now-button-label": _unref(t)('現在を選択')
            }, null, 8, ["modelValue", "format", "disabled-dates", "locale", "placeholder", "now-button-label"])
          ], undefined, true),
          _: 1
        })
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (isShowLabel())
          ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_unref(t)(_ctx.labelName)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(VueDatePickerComponent, null, {
            default: _withCtx(() => [
              _createVNode(AppDatePicker, {
                modelValue: date.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((date).value = $event)),
                class: "date-field__input",
                "mode-height": 1,
                format: _ctx.format,
                "enable-time-picker": true,
                "month-change-on-scroll": false,
                "week-start": "0",
                locale: locale.value,
                placeholder: _unref(t)('日付を選択'),
                "select-text": _unref(t)('選択'),
                "cancel-text": _unref(t)('キャンセル'),
                "show-now-button": true,
                "now-button-label": _unref(t)('現在を選択'),
                pad: ""
              }, null, 8, ["modelValue", "format", "locale", "placeholder", "select-text", "cancel-text", "now-button-label"])
            ], undefined, true),
            _: 1
          })
        ])
      ]))
}
}

})